import { render, staticRenderFns } from "./CompanyBox.vue?vue&type=template&id=7fecb84a&scoped=true&"
import script from "./CompanyBox.vue?vue&type=script&lang=js&"
export * from "./CompanyBox.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBox.vue?vue&type=style&index=0&id=7fecb84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fecb84a",
  null
  
)

export default component.exports